import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

// items: array de strings ou objetos { label, to }
const Breadcrumbs = ({ items }) => {
  return (
    <nav className="breadcrumbs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const label = typeof item === 'string' ? item : item.label;
        const to = typeof item === 'string' ? null : item.to;

        return (
          <React.Fragment key={index}>
            {index > 0 && <span className="breadcrumbs-separator"> &gt; </span>}
            {isLast || !to ? (
              <span className={isLast ? 'breadcrumbs-current' : 'breadcrumbs-link'}>
                {label}
              </span>
            ) : (
              <Link to={to} className="breadcrumbs-link">
                {label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
